import { useEffect, useState } from "react";

function checkAnalyticsConsent() {
  return (
    typeof window.OnetrustActiveGroups !== "undefined" &&
    window.OnetrustActiveGroups.includes(",C0004,")
  );
}

export function useOneTrust() {
  const [hasAnalyticsConsent, setHasAnalyticsConsent] = useState(false);

  useEffect(() => {
    const setupOneTrust = async () => {
      console.log("Waiting for OneTrust to be ready...");

      // Wait for OneTrust to load
      await window.__oneTrustReady;

      console.log("OneTrust is ready!");

      // Check initial consent
      const analyticsConsent = checkAnalyticsConsent();
      setHasAnalyticsConsent(analyticsConsent);

      if (analyticsConsent) {
        console.log("✅ Analytics consent given on page load");
      } else {
        console.log("❌ No analytics consent on page load");
      }

      // Listen for consent changes
      window.addEventListener("OneTrustGroupsUpdated", (_event) => {
        console.log("🔄 Consent updated");
        const newConsent = checkAnalyticsConsent();

        setHasAnalyticsConsent(newConsent);
        if (newConsent) {
          console.log("✅ Analytics consent now given");
        } else {
          console.log("❌ Analytics consent removed");
        }
      });
    };

    setupOneTrust();
  }, []);

  return { hasAnalyticsConsent: hasAnalyticsConsent };
}
